module.exports = __webpack_public_path__ + "img/ic-sparkles-black.30731519.svg";